import { ExternalPageConfig } from 'frontend-container/externalPages/externalPagesConfig';
import { ContextHelpView } from 'frontend-container/externalPages/pages/ContextHelp/ContextHelpView';

export const ContextHelpExternalPageConfig: ExternalPageConfig = {
  pagePathname: 'context-help',
  component: <ContextHelpView />,
};
